import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';
import Section from '../components/Section.jsx';

const PLACES = [
  {
    href: '/modiya-mahadev',
    kicker: '25 km',
    title: 'Modiya Mahadev',
    copy: 'A thousand-year-old Shiva temple on an Aravalli hilltop, and the Shyama ashram below it.',
    image: '/images/modiya-mahadev/modiya-mahadev1.jpg',
  },
  {
    href: '/paangarh',
    kicker: '12 km',
    title: 'Paangarh',
    copy: "The district's largest natural lake, held full for three hundred years, with boating and camp fires.",
    image: '/images/paangarh/paangarh1.jpg',
  },
  {
    href: '/bijaipur',
    kicker: 'Mewar',
    title: 'Bijaipur',
    copy: 'The old estate seat, its palace hotels and the 60 villages that still call it home.',
    image: '/images/about/amarpura2.JPG',
  },
];

const FACTS = [
  { value: '500', label: 'Years since Amara founded the village' },
  { value: '17', label: 'Villages in the gram panchayat' },
  { value: '3,100', label: 'People in the panchayat' },
  { value: '2,000 L', label: 'Milk collected every day' },
];

const Home = () => (
  <div id="page">
    <Header
      tall
      kicker="Chittorgarh · Rajasthan"
      heading="Amarpura"
      tagline="A village in the green hills of the Aravallis."
    >
      <div className="btn-row">
        <a className="btn" href="/about">
          Explore the village
        </a>
        <a className="btn btn--ghost" href="/paangarh">
          See Paangarh lake
        </a>
      </div>
    </Header>

    <Section
      center
      narrow
      eyebrow="Dream village"
      title="Ek visit to banta hai."
      lead="Five centuries of history between the hills — temples, a three-hundred-year-old lake, and seventeen villages that still run on the same panchayat."
    />

    <Section title="Places near by" lead="Three short drives from Amarpura.">
      <div className="card-grid">
        {PLACES.map(({ href, kicker, title, copy, image }, i) => (
          <a
            key={href}
            className="card reveal"
            data-reveal-index={i}
            href={href}
            style={{ backgroundImage: `url(${image})` }}
          >
            <p className="card__kicker">{kicker}</p>
            <h3>{title}</h3>
            <p>{copy}</p>
          </a>
        ))}
      </div>
    </Section>

    <Section tint title="Amarpura by the numbers">
      <div className="tile-grid">
        {FACTS.map(({ value, label }, i) => (
          <div key={label} className="tile reveal" data-reveal-index={i}>
            <span className="tile__value">{value}</span>
            <span className="tile__label">{label}</span>
          </div>
        ))}
      </div>
    </Section>

    <Section center narrow title="Be the first to visit among your friends.">
      <div className="btn-row reveal" style={{ justifyContent: 'center' }}>
        <a className="btn" href="/contact-us">
          Get in touch
        </a>
      </div>
    </Section>

    <Footer />
  </div>
);

export default Home;
